import { z } from 'zod'
import { Model } from '../../_kernel/architecture'

export type Sources = (typeof ALLOWED_SOURCES)[number]

export const ALLOWED_SOURCES = ['web', 'meta', 'email'] as const

export const SourceValidation = z.object({
  value: z.enum(ALLOWED_SOURCES, { required_error: 'value is required' }),
})

export class Source extends Model {
  static DEFAULT_SOURCE = 'web'

  static create({ value }: z.infer<typeof SourceValidation>) {
    SourceValidation.parse({ value })
    return new Source(value)
  }

  static createOrEmpty({ value }: z.infer<typeof SourceValidation>) {
    try {
      return Source.create({ value })
    } catch {
      return Source.empty()
    }
  }

  static empty() {
    return new Source()
  }

  constructor(private readonly _value?: (typeof ALLOWED_SOURCES)[number]) {
    super()
  }

  isEmpty(): this is Source & { value: undefined } {
    return !this._value
  }

  isFilled(): this is Source & z.infer<typeof SourceValidation> {
    return !!this._value
  }

  isDefault(): this is Source & { value: 'web' } {
    return this._value === Source.DEFAULT_SOURCE
  }

  isNotDefault(): this is Source & { value: Exclude<Sources, 'web'> } {
    return this._value !== Source.DEFAULT_SOURCE
  }

  get value() {
    return this._value
  }

  toJSON() {
    return { value: this._value ?? null }
  }
}
